import { clsx, ClassValue } from 'clsx';

/**
 * Utility function for merging class names
 *
 * Uses clsx for conditional classes.
 * NOTE: no tailwind-merge, so conflicting Tailwind utilities are NOT resolved (className overrides don't win).
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
